module.exports = __webpack_public_path__ + "img/0xbfa0841f7a90c4ce6643f651756ee340991f99d5.cf22fbb4.png";